export const recentBookingOrderTabs = ['주문', '예약'] as const

export type RecentBookingOrderTab = (typeof recentBookingOrderTabs)[number]
